import actionTypes from './actionTypes';

const initialState = {
  shipment: {
    sid: null,
    iid: null,
    quote: {},
    summary: {},
  },
  isFetching: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH:
      return {
        ...state,
        shipment: initialState.shipment,
        isFetching: true,
      };
    case actionTypes.FETCHING:
      return {
        ...state,
        shipment: initialState.shipment,
        isFetching: true,
      };
    case actionTypes.FETCHED:
      return {
        ...state,
        shipment: action.payload.shipment,
        isFetching: false,
      };
    default:
      return state;
  }
};
